module.exports = __webpack_public_path__ + "static/BhavukaRegular400-7d1f64f2e62bbe9653a78b3a0bee8b78.ttf";